// @ts-expect-error - TS7016 - Could not find a declaration file for module 'query-string'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/query-string/index.js' implicitly has an 'any' type.
import queryString from "query-string";
class ParamsService {
    static getURLWithParams(params, url = window.location.href) {
        const parsedUrl = queryString.parseUrl(url);
        const paramString = ParamsService.toQueryString(Object.assign(Object.assign({}, parsedUrl.query), params));
        if (paramString) {
            return parsedUrl.url + "?" + paramString;
        }
        return parsedUrl.url;
    }
    static calcNewParams(params, url = window.location.href) {
        const parsedUrl = queryString.parseUrl(url);
        return ParamsService.toQueryString(Object.assign(Object.assign({}, parsedUrl.query), params));
    }
    static updateCurrentParams(params) {
        const newParamString = ParamsService.calcNewParams(params);
        if (!newParamString) {
            return window.location.pathname;
        }
        return window.location.pathname + "?" + newParamString;
    }
    static getLinkWithAdditionalParams(params, url = window.location.href) {
        const newParams = ParamsService.calcNewParams(params, url);
        if (!newParams) {
            return url;
        }
        return url + "?" + newParams;
    }
    static _serializeQueryComponent(component) {
        if (component instanceof Date) {
            return component.toJSON();
        }
        return encodeURIComponent(component);
    }
}
ParamsService.toQueryString = (params) => {
    // @ts-expect-error - TS7034 - Variable 'definedParams' implicitly has type 'any' in some locations where its type cannot be determined.
    let definedParams;
    if (params && Object.keys(params).length) {
        // Defensive copy so flow type refinement isn't invalidated.
        definedParams = params;
    }
    else {
        return "";
    }
    return (Object.keys(definedParams)
        // @ts-expect-error - TS7005 - Variable 'definedParams' implicitly has an 'any' type.
        .filter((key) => definedParams[key] != null)
        .map((key) => {
        // @ts-expect-error - TS7005 - Variable 'definedParams' implicitly has an 'any' type.
        if (Array.isArray(definedParams[key])) {
            // @ts-expect-error - TS7005 - Variable 'definedParams' implicitly has an 'any' type.
            if (!definedParams[key].length) {
                return encodeURIComponent(key) + "=";
            }
            // @ts-expect-error - TS7005 - Variable 'definedParams' implicitly has an 'any' type.
            return definedParams[key]
                .map(
            // @ts-expect-error - TS7006 - Parameter 'val' implicitly has an 'any' type.
            (val) => `${encodeURIComponent(key)}=${ParamsService._serializeQueryComponent(val)}`)
                .join("&");
        }
        return `${encodeURIComponent(key)}=${ParamsService._serializeQueryComponent(definedParams[key])}`;
    })
        .filter((val) => val && val !== "")
        .join("&"));
};
export default ParamsService;
